export default __webpack_public_path__ + "static/learning-40b90293d67857b6a2215ca63c5369ab.svg";